import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CheckIcon from '@mui/icons-material/Check';
import { StepIconProps } from '@mui/material/StepIcon';
import './claim-stepper.scss';

const steps = [
  {
    label: 'Claim submitted',
  },
  {
    label: 'Claim Cleared',
  },
  {
    label: 'Claim Assigned',
  },
  {
    label: 'Set Initial Reserve',
  },
  {
    label: 'Claim step 4',
  },
  {
    label: 'Claim step 5',
  },
];

const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed } = props;

  return (
    <div
      className={`
        step-icon-root
        ${active ? 'step-icon-active' : ''}
        ${completed ? 'step-icon-completed' : ''}
      `}
    >
      {completed ? <CheckIcon fontSize="small" /> : ''}
    </div>
  );
};

export const ClaimStepper = ({ activeStep = 3 }: { activeStep?: number }) => {
  return (
    <Box className="claim-stepper-container">
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              classes={{
                root: 'MuiStepLabel-root',
                completed: 'MuiStepLabel-completed',
                labelContainer: 'MuiStepLabel-labelContainer',
              }}
              StepIconComponent={CustomStepIcon}
            >
              {index === activeStep ? step.label : null}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default ClaimStepper;
